import { removeAccents } from '../utils/stringNormalization';
export const COUNTRIES = [
  {
    code: "EC",
    isoA3: "ECU",
    name: "Ecuador",
    bcCountryCode: "EC",
    currency: "USD",
    currencySymbol: "$",
    thousandSeparator: ",",
    decimalSeparator: ".",
    currencyPosition: "prefix", //prefix ó suffix como opciones válidas
    decimals: 2
  },
  {
    code: "PY",
    isoA3: "PRY",
    name: "Paraguay",
    bcCountryCode: "PY",
    currency: "PYG",
    currencySymbol: "₲",
    thousandSeparator: ".",
    decimalSeparator: ",",
    currencyPosition: "prefix",
    decimals: 0
  },
  {
    code: "HN",
    isoA3: "HND",
    name: "Honduras",
    bcCountryCode: "HN",
    currency: "HNL",
    currencySymbol: "L",
    thousandSeparator: ",",
    decimalSeparator: ".",
    currencyPosition: "prefix",
    decimals: 2
  },
  {
    code: "PE",
    isoA3: "PER",
    name: "Perú",
    bcCountryCode: "PE",
    currency: "PEN",
    currencySymbol: "S/",
    thousandSeparator: ",",
    decimalSeparator: ".",
    currencyPosition: "prefix",
    decimals: 2
  },
  {
    code: "BO",
    isoA3: "BOL",
    name: "Bolivia",
    bcCountryCode: "BO",
    currency: "BOB",
    currencySymbol: "Bs",
    thousandSeparator: ".",
    decimalSeparator: ",",
    currencyPosition: "prefix",
    decimals: 2
  },
  {
    code: "GT",
    isoA3: "GTM",
    name: "Guatemala",
    bcCountryCode: "GT",
    currency: "GTQ",
    currencySymbol: "Q",
    thousandSeparator: ",",
    decimalSeparator: ".",
    currencyPosition: "prefix",
    decimals: 2
  },
  {
    code: "SV",
    isoA3: "SLV",
    name: "El Salvador",
    bcCountryCode: "SV",
    currency: "USD",
    currencySymbol: "$",
    thousandSeparator: ",",
    decimalSeparator: ".",
    currencyPosition: "prefix",
    decimals: 2
  }
];

// Mapa para usar claves fácilmente en configs o condicionales
export const COUNTRY_CODES = COUNTRIES.reduce((acc, country) => {
  acc[
    removeAccents(country.name)
      .replace(/\s+/g, '')
      .toUpperCase()
  ] = country.code;
  return acc;
}, {});